import React, { useState, useRef, useEffect } from 'react';
import "./Subscriptions.css"
import sub1 from "../../images/sub1.png";
import sub2 from "../../images/sub2.png";
import tik from "../../images/sub-tick.png";
import s3 from "../../images/shape3.png";
import s4 from "../../images/shape4.png";
import s5 from "../../images/shape5.png";


import vl from "../../images/vl.png";
import pl from "../../images/pl.png";
import bl from "../../images/bl.png";
import yl from "../../images/yl.png";
import ylimg from "../../images/ylim.png";

import axios from 'axios';
import { END_URL, IMG_URL } from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import buttonloader from "../../images/buttonloader.gif";
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function SubscriptionModal({ subs, userdetail, Subcription, onLoginChange }) {
  const [ButtonLoad, setButtonLoad] = useState(null);

    const [FreeTestAttend,setFreeTestAttend] = useState(Subcription?.user_attent_free_test);

    const [FreeTestSub,setFreeTestSub] = useState(Subcription?.user_have_free_test_sub);

    const [FreeTest,setFreeTest] = useState(Subcription?.test);

    const [showPopup,setshowPopup] = useState(false);

    const [showFreeSub,setshowFreeSub] = useState(false);

    const subS = true;

    const [subscriptionmodal, setSubscriptionModal] = useState(null);

    const [ShowModal, setShowModal] = useState(false);


    const navigate = useNavigate();

    const images = [vl, pl, bl, yl];

    const LoginShow = () => {

        // window.scrollTo({ top: 0, behavior: 'smooth' });
        onLoginChange(true);
    };

    const token = localStorage.getItem('token');

    const handleNavigate = (slug) => {

        if (slug && slug.trim() !== "") {
            navigate(`/test/${slug}`);
        }
    };

    const AttentTest = () =>
    {
        setshowPopup(true);
    }

    const TakeFreeSub = () =>
    {
        setshowFreeSub(true);
    }

    const handleSpecial = (slug) => {

            navigate(`/${slug}`);
    };

    const handleSub = async (subJson) => {
        try {
            setShowModal(true);

            let subIds = subJson;

            if (typeof subJson === "string") {
            try {
                subIds = JSON.parse(subJson);
            } catch (e) {
                console.error("Invalid JSON string for subIds:", e);
                return;
            }
            }

            if (!Array.isArray(subIds) || subIds.length === 0) {
            console.warn("No valid subscription IDs found:", subIds);
            return;
            }

            const res = await axios.post(
            `${END_URL}/sub_adver`,
            { ids: subIds },
            {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            }
            );

            setSubscriptionModal(res.data);
        } catch (err) {
            console.error("Error loading subscriptions:", err);
        }
    };


    const HandlePayment = (item) => {

        const InitializePayment = async () => {

            try {

                setButtonLoad(item.id);

                const response = await fetch(`${END_URL}/test-payment`, {

                    method: "POST",
                    headers: {

                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(item)

                });

                const data = await response.json();

                console.log(data.payment, 'fetch data');

                if (data.payment) {

                    setButtonLoad(null);
                    window.location.href = data.payment;

                } else {

                    setButtonLoad(null);

                    console.error("Invalid response:", data);
                    alert("An error occurred while processing the request.");
                }

            } catch (error) {

                console.error("Error sending result:", error);
            }
        };

        InitializePayment();

    };

    const [showDropdown, setShowDropdown] = useState(null); 
    const dropdownRef = useRef(null);

        useEffect(() => {
        function handleClickOutside(event) {
            if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
            ) {
            setShowDropdown(null); 
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const all_user_access = userdetail?.user_all_access == '1' ? true : false;

    return (

        <div className="subs-main">
            
            <div className="subs-sub-main">

                {!showPopup && !showFreeSub && (

                    <div className="row1 subs-title">

                        <div className="subs-header" dangerouslySetInnerHTML={{ __html: Subcription?.sub_content }}>

                        </div>

                    </div>
                )}

                <div className={subs ? 'row gy-4 subs-card-row subs-two' : 'row gy-4 subs-card-row'}>

                    <div className="col-12 col-sm-12 col-md-12" >


                        {Subcription && (

                            Subcription?.data?.map((item, index) => (

                                <div 
                                    className={`row content-row ${ item.user_have_month || all_user_access ? (item.month_sub_highest || (item.type==='one_time' && item.month_sub_default) || all_user_access ? 'sub-yes' : 'sub-grey') : 'sub-no'}`}

                                    key={index} style={{
                                    backgroundImage: `url(${images[index % images.length]})`, backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover'
                                }}>

                                    <div className={subs ? 'sub-for-large-none-col-md-3' : 'col-md-3'}>
                                        <div className="subs-right ">
                                            <img src={`${IMG_URL}/d0/${item.image}`} alt="" />
                                        </div>
                                    </div>
                                    <div className={subs ? "sub-for-col-md-9" : 'col-md-9'}>

                                        <div className="subs-left">
                                            
                                            <div className="subs-box">
                                                    <h5> {item.title}</h5>

                                                    <div className="subs-amt">

                                                        <span>${item.price ?? item.actual_price}</span>

                                                        <span style={{ display: item.have_discount === false || !item.price ? 'none' : 'inline' }} data-price={item.actual_price}>${item.actual_price}</span>

                                                    </div>

                                                    {item.image && (
                                                        
                                                        <div className={subs ? 'subs-right sub-for-large' : "sub-for-large-none"}>
                                                            <img src={`${IMG_URL}/d0/${item.image}`} alt="" />
                                                        </div>
                                                    )}
                                            </div>
                                
                                            <div  className={subs ? 'sub-for-content' : "" } dangerouslySetInnerHTML={{ __html: item.description }} />

                                            {token ? (
                                                (
                                                    (
                                                        ( !all_user_access && ( (item.type === 'one_time' && !item.user_have_month ) || (item.type === 'monthly' && !item.user_have_month ) || (item.type =='other' && (item.plan_type =='zoom' || (item.plan_type =='deep_drive' &&  !userdetail?.deep_sub ) ) ) ) )

                                                    ) ? (

                                                         item.dont_allow_subscription !=0 ? (

                                                             item.special_link ? (

                                                                <button onClick={() => handleSpecial(item?.special_link)}>
                                                                    {item.heading}
                                                                    <span>
                                                                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                                    </span>
                                                                </button>
                                                             ):(

                                                                <button
                                                                
                                                                // onClick={() => handleSpecial(item?.special_link)}
                                                                   onClick={
                                                                                () => handleSub(item?.add_sub)
                                                                            }
                                                                
                                                                >
                                                                    {item.heading}
                                                                    <span>
                                                                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                                    </span>
                                                                </button>
                                                             )
                                                        ):
                                                        (
                                                            item.type === 'other' ? (

                                                                FreeTestSub ? (

                                                                       FreeTestAttend ? (

                                                                            <button onClick={() => HandlePayment(item)}>

                                                                                {item.heading} <span> {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}</span> {ButtonLoad === item.id && <img index={index} src={buttonloader} alt="Loading" />}

                                                                            </button>
                                                                        ):
                                                                        (
                                                                            <button onClick={() =>AttentTest() } >

                                                                                {item.heading} <span> {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}</span> {ButtonLoad === item.id && <img index={index} src={buttonloader} alt="Loading" />}
                                                                            </button>
                                                                        )
                                                                ):
                                                                (
                                                                    <button onClick={() =>TakeFreeSub() } >

                                                                        {item.heading} <span> {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}</span> {ButtonLoad === item.id && <img index={index} src={buttonloader} alt="Loading" />}
                                                                    </button>
                                                                )
                                                            ) :
                                                            (
                                                                <button onClick={() => HandlePayment(item)}>
                                                                {item.heading}<span> {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}</span> {ButtonLoad === item.id && <img index={index} src={buttonloader} alt="Loading" />}
                                                                </button>
                                                            )
                                                        )

                                                    ) : (
                                                            item.test_multiple ? (

                                                                item?.special_link ? (
                                        
                                                                <button onClick={() => handleSpecial(item?.special_link)}>
                                                                     {item.heading} 
                                                                    <span>
                                                                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                                    </span>
                                                                </button>

                                                            ) : (

                                                                <button ref={showDropdown === index ? dropdownRef : null} onClick={() => setShowDropdown(showDropdown === index ? null : index)} >
                                                                    {item.heading}  
                                                                    <span>
                                                                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                                    </span>

                                                                    {showDropdown === index && (
                                                                        <div className="dropdown navDrope">
                                                                            <div id="test-drop" className="dropdown-content show">
                                                                            {item.test_disable?.map((test, idx) => (
                                                                                <a 
                                                                                key={idx} 
                                                                                href="#" 
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                    setShowDropdown(null);
                                                                                    handleNavigate(test.slug);
                                                                                }}
                                                                                >
                                                                                {test.name}
                                                                                </a>
                                                                            ))}
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                </button>
                                                            )
                                                                
                                                            ) :
                                                            (
                                                                 item?.special_link ? (
                                                
                                                                    <button onClick={() => handleSpecial(item?.special_link)}>
                                                                        {item.heading} 
                                                                        <span>
                                                                            <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                                        </span>
                                                                    </button>

                                                                ) : (

                                                                    <button onClick={() => handleNavigate(item.test_disable?.slug)} >

                                                                        {item.heading}  <span><FontAwesomeIcon className="icc" icon={faArrowRight} /></span>

                                                                    </button>
                                                                )
                                                            )
                                                    )
                                                )
                                            ) : (

                                               item?.special_link && item.dont_allow_subscription ==1 ? (
                                                
                                                    <button onClick={() => handleSpecial(item?.special_link)}>
                                                        {item.heading} 
                                                        <span>
                                                            <FontAwesomeIcon className="icc" icon={faArrowRight} /> 
                                                        </span>
                                                    </button>

                                                ) : (
                                                    
                                                    <button onClick={LoginShow}>
                                                        {item.heading} 
                                                        <span>
                                                            <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                        </span>
                                                    </button>
                                                )
                                            )}


                                        </div>
                                    </div>



                                </div>

                            ))

                        )}

                    </div>


                </div>


                   {showPopup && (
                
                        <div className="newdashpop-overlay subs-cognit-modal1">
                            <div className="newdashpop-inner">
                            <div className="newdashpop-container">
                                <button
                                className="newdashpop-close"
                                onClick={() => setshowPopup(false)}
                                >
                                &times;
                                </button>
    
                                <div className="conent-pop" dangerouslySetInnerHTML={{ __html: FreeTest?.not_attend_free_test}} />

                                <a
                                    className="home-slider-sun-box-a"
                                    href={`test/${FreeTest?.slug}`}
                                    rel="noopener noreferrer"
                                >
                                <span className="home-slider-sun-box-a-text">{FreeTest?.not_attend_free_test_label}</span>
                                <span className="home-slider-sun-box-a-icon">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                </a>
                            </div>
                            </div>
                        </div>
                    )}

                    {showFreeSub && (
                
                        <div className="newdashpop-overlay subs-cognit-modal1">
                            <div className="newdashpop-inner">
                                <div className="newdashpop-container  sub-no">
                                    <button
                                        className="newdashpop-close"
                                        onClick={() => setshowFreeSub(false)}
                                        >
                                    &times;
                                    </button>
            
                                    <div className="conent-pop subs-left">
                                        
                                       <div className="conent-pop-text" dangerouslySetInnerHTML={{ __html: FreeTest?.not_have_free_test}} />

                                        <button   onClick={() => HandlePayment(FreeTest?.sub)} >
                                        
                                            {FreeTest?.not_have_free_test_label}

                                            <span>

                                                {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}
                                                
                                            </span> {ButtonLoad === FreeTest?.sub?.id && <img  src={buttonloader} alt="Loading" />}
                                    
                                        </button>

                                    </div>
            
                                
                                </div>
                            </div>
                        </div>
                    )}

            </div>

        </div>
    )
}

export default SubscriptionModal;
